export default __webpack_public_path__ + "static/media/Image10.19ca2e6f.png";